export class Subject {
    public principal: string;
    public password: string;
    public communicationCode;
}



// WEBPACK FOOTER //
// ./src/app/resources/classes/subject.ts